import React from 'react'
import { StyledContent } from './styles/Content.styled'
import Slider from "react-slick";


import Group2 from '../../../../assets/images/Group2.png'
import Group6 from '../../../../assets/images/Group6.png'
import Group from '../../../../assets/images/Group.png'
import Group1 from '../../../../assets/images/Group1.png'
import Button from '../reusable_ui/button/Button'
import {Link} from 'react-router-dom'

const Content = () => {
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      };

  return (
    <StyledContent>
        <Slider  {...settings}>
        
            
                            {/* {' '} */}
                    <div className='content__space'>
            
                        <div className='Content1'>
                            <div className='content__left'>
                                        <div>
                                            <h1 className="content__title1">Modern online energy monitoring for Africa</h1>
                                            <p className="content__desc">HydroCIS is Nigeria and West Africa’s First Energy Information Platform</p>
                                        </div>
                                        {' '}
                                        <Link to='/user/login'>  <Button> Sign In</Button> </Link>
                                </div>
                    
                            <div className='Content__image1'>
                                        <div>
                                                <div className='content_below'>
                                                    <img src={Group6} alt='blue_3angle'/>
                                                    <img src={Group2} alt='green_3angle'/>
                                                </div>
                                                
                                            <img src={Group}  className='content_img' alt='img' />
                                        </div>
                            </div>
                                        <></>
                        </div>
                   </div> 
                            {/* {' '} */}
                    <div className='content__space'>
                        
                        <div className='Content1'>
                            <div className='content__left'>
                                        <div>
                                            <h1 className="content__title1">Modern online energy monitoring for Africa</h1>
                                            <p className="content__desc">HydroCIS is Nigeria and West Africa’s First Energy Information Platform</p>
                                        </div>
                                        {' '}
                                    <Button> Sign In</Button>
                                </div>
                    
                            <div className='Content__image1'>
                                        <div>
                                                <div className='content_below'>
                                                    <img src={Group6} alt='blue_3angle'/>
                                                    <img src={Group2} alt='green_3angle'/>
                                                </div>
                                                
                                            <img src={Group1}  className='content_img' alt='img' />
                                        </div>
                            </div>
                                        <></>
                        </div>
                    </div> 
            {/* <></> */}
       </Slider> 
</StyledContent>
  )
}

export default Content